import './style.css';

import React from 'react';
import { Button } from '@economic/gaudi';

import { Field, Form } from '../../../shared/components/Form';
import { t, useLocalization } from '../../../shared/components/l10n/l10n';
import useQuery from '../../../shared/hooks/useQuery';
import internalApiClient from '../../../shared/util/api/internalApiClient';

export default function DpaEditDialog({ hide }) {
    const textsLoading = useLocalization(textIds);
    const companyTermsQuery = useQuery('company/terms', {});

    if (textsLoading || companyTermsQuery.loading) {
        return null;
    }

    async function submitUpdate({ hasSensitiveData }: { hasSensitiveData: boolean }) {
        await internalApiClient.post('company/terms', { hasSensitiveData });
        hide();
    }

    function cancel(e) {
        e.preventDefault();
        hide();
    }

    return (
        <div className="dpa-edit-dialog">
            <h1>{t`TERMSCONDITIONS_EDIT_PAGE_TITLE`}</h1>

            <p>{t`TERMSCONDITIONS_EDIT_PAGE_HOW_TO_EDIT`}</p>

            <p>{t`TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_TITLE`}</p>

            <ul>
                <li>{t`TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_1`}</li>
                <li>{t`TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_2`}</li>
                <li>{t`TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_3`}</li>
                <li>{t`TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_4`}</li>
                <li>{t`TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_5`}</li>
                <li>{t`TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_6`}</li>
            </ul>

            <Form
                initialData={{ hasSensitiveData: companyTermsQuery.data.hasSensitiveData ? 'true' : 'false' }}
                onSubmit={submitUpdate}>
                <section className="sensitive-data">
                    <Field.RadioGroup
                        name="hasSensitiveData"
                        options={[
                            {
                                text: t`TERMSCONDITIONS_DPA_FOOTER_YES`,
                                value: 'true',
                            },
                            {
                                text: t`TERMSCONDITIONS_DPA_FOOTER_NO`,
                                value: 'false',
                            },
                        ]}
                    />
                </section>

                <p>{t`TERMSCONDITIONS_EDIT_PAGE_SENSITIVE_INFORMATION_FOOTER`}</p>

                <div className="form__buttons">
                    <Button type="submit" appearance="primary">{t`TERMSCONDITIONS_EDIT_PAGE_BUTTON_UPDATE`}</Button>
                    <Button appearance="discrete" onClick={cancel}>{t`TERMSCONDITIONS_EDIT_PAGE_BUTTON_CANCEL`}</Button>
                </div>
            </Form>
        </div>
    );
}

const textIds = [
    'TERMSCONDITIONS_EDIT_PAGE_TITLE',
    'TERMSCONDITIONS_EDIT_PAGE_HOW_TO_EDIT',

    'TERMSCONDITIONS_EDIT_PAGE_SENSITIVE_INFORMATION_FOOTER',
    'TERMSCONDITIONS_EDIT_PAGE_BUTTON_UPDATE',
    'TERMSCONDITIONS_EDIT_PAGE_BUTTON_CANCEL',
    'TERMSCONDITIONS_DPA_FOOTER_YES',
    'TERMSCONDITIONS_DPA_FOOTER_NO',

    'TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_TITLE',
    'TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_1',
    'TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_2',
    'TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_3',
    'TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_4',
    'TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_5',
    'TERMSCONDITIONS_DPA_SENSITIVE_INFORMATION_BULLET_6',
];
